var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-input", {
    attrs: {
      placeholder: "输入关键字进行过滤"
    },
    model: {
      value: _vm.filterText,
      callback: function callback($$v) {
        _vm.filterText = $$v;
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c("el-tree", {
    ref: "tree",
    staticClass: "filter-tree",
    attrs: {
      data: _vm.treeData,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "ID",
      props: _vm.defaultProps,
      "default-checked-keys": _vm.selectedAllIds,
      "filter-node-method": _vm.filterNode,
      getCheckedNodes: ""
    },
    on: {
      check: _vm.handleCheckFunc
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };